(function () {
  'use strict';

  angular.module('app').component('clientProfilesPage', clientProfileListComponent());

  function clientProfileListComponent() {
    return {
      bindings: {},
      controller: ClientProfileListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/client-profiles/client-profiles-page.component.html',
    };
  }

  ClientProfileListCtrl.$inject = ['$location', 'AbilityService', 'ClientProfileService'];

  function ClientProfileListCtrl($location, AbilityService, ClientProfileService) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_clientprofile_accountadmin'),
    };

    // Methods
    vm.createItem = createItem;
    vm.onShowItem = onShowItem;

    // Initializers
    getItems();

    function getItems() {
      vm.loadingItems = true;
      ClientProfileService.getClientProfiles().then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function createItem() {
      $location.path('/client_profiles/new');
    }

    function onShowItem(item) {
      $location.path(`/client_profiles/${item.id}`);
    }
  }
})();
